import { Badge, Box, Flex, Heading, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";

interface Props {
  title: string;
  count: number;
  description: string;
  children: ReactNode;
}

export const TemplateSectionCard = ({ title, count, description, children }: Props) => (
  <Box borderWidth="1px" borderColor="smBorder" borderRadius="xl" bg="smBackground" p="6">
    <Flex align="center" gap="2" mb="1">
      <Heading as="h3" size="md" color="smText">
        {title}
      </Heading>
      <Badge borderRadius="full" px="2.5" colorScheme="gray" fontSize="xs">
        {count}
      </Badge>
    </Flex>
    <Text color="smMuted" fontSize="sm" mb="4">
      {description}
    </Text>
    {children}
  </Box>
);
